/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = new Model({
	name: "machineevents",
	init: init,
	triggers: triggers,
	listeners: listeners,

	subscribeEvents: subscribeEvents,
	unsubscribeEvents: unsubscribeEvents,

	flushBuffer: flushBuffer,
	bufferEvent: bufferEvent,

	_serial: null,
	_eventBuffer: [],
});

function init() {
	this.push({
		finding: []
	});
}

function triggers() {
	return {
		// Sent to other machines
		"find": trigger_find,
		"find:finish": trigger_find_finish,
		"found": trigger_found,
		"take": trigger_take,
		"taken": trigger_taken,
		"taking": trigger_taking,
		"failed": trigger_failed,

		// State of current machine
		"state:reconnecting": trigger_state_reconnecting,
		"state:take": trigger_state_take,
		"state:ignored": trigger_state_ignored,
		"state:scanning": trigger_state_scanning,
		"state:scanned": trigger_state_scanned,
		"state:finding": trigger_state_finding,
		"state:bluetooth": trigger_state_bluetooth,
		"state:bluetooth:error": trigger_state_bluetooth_error,
		"state:calling:error": trigger_state_calling_error,
	};
}

function listeners() {
	return {
		"machinetracker:updated": handleMachineTrackerUpdated,
	};
}

function handleMachineTrackerUpdated(data) {
	var new_serial = data.serial;
	var old_serial = this._serial;
	this._serial = new_serial;

	if (old_serial === new_serial) return;

	if (old_serial) {
		this.unsubscribeEvents(old_serial);
	}

	this.subscribeEvents(new_serial);

	if (this._eventBuffer.length)
		this.flushBuffer();
}

function unsubscribeEvents(serial) {
	this.tracker.off("mqtt:machine/" + serial + "/find");
	this.tracker.off("mqtt:machine/" + serial + "/find/finish");
	this.tracker.off("mqtt:machine/" + serial + "/found");
	this.tracker.off("mqtt:machine/" + serial + "/take");
	this.tracker.off("mqtt:machine/" + serial + "/taken");
}

function subscribeEvents(serial) {
	this.tracker.on("mqtt:machine/" + serial + "/find", makeEmitter(this, "find"));
	this.tracker.on("mqtt:machine/" + serial + "/find/finish", makeEmitter(this, "find:finish"));
	this.tracker.on("mqtt:machine/" + serial + "/found", makeEmitter(this, "found"));
	this.tracker.on("mqtt:machine/" + serial + "/take", makeEmitter(this, "take"));
	this.tracker.on("mqtt:machine/" + serial + "/taken", makeEmitter(this, "taken"));
	this.tracker.on("mqtt:machine/" + serial + "/taking", makeEmitter(this, "taking"));
	this.tracker.on("mqtt:machine/" + serial + "/failed", makeEmitter(this, "failed"));
}

function makeEmitter(model, event) {
	return function (data) {
		model.dispatch(event, data);
	};
}

function trigger_find(data) {
	if (!this._serial) return this.bufferEvent("find", data);
	this.emit("$mqtt:machine/" + data.machine + "/find", {
		bracelet: data.bracelet,
		model: data.model,
		from: this._serial
	});
}

function trigger_find_finish(data) {
	if (!this._serial) return this.bufferEvent("find:finish", data);
	this.emit("$mqtt:machine/" + data.machine + "/find/finish", {
		bracelet: data.bracelet,
		from: this._serial
	});
}

function trigger_found(data) {
	if (!this._serial) return this.bufferEvent("found", data);
	this.emit("$mqtt:machine/" + data.machine + "/found", {
		bracelet: data.bracelet,
		from: this._serial,
		rssi: data.rssi
	});
}

function trigger_take(data) {
	if (!this._serial) return this.bufferEvent("take", data);

	this.emit("$mqtt:machine/" + data.machine + "/take", {
		bracelet: data.bracelet,
		model: data.model,
		from: this._serial
	});
}

function trigger_taken(data) {
	if (!this._serial) return this.bufferEvent("taken", data);
	this.emit("$mqtt:machine/" + data.machine + "/taken", {
		bracelet: data.bracelet,
		from: this._serial
	});
}

function trigger_taking(data) {
	if (!this._serial) return this.bufferEvent("taking", data);
	this.emit("$mqtt:machine/" + data.machine + "/taking", {
		bracelet: data.bracelet,
		from: this._serial
	});
}

function trigger_failed(data) {
	if (!this._serial) return this.bufferEvent("failed", data);
	this.emit("$mqtt:machine/" + data.machine + "/failed", {
		bracelet: data.bracelet,
		from: this._serial
	});
}

function trigger_state_reconnecting(data) {
	if (!this._serial) return this.bufferEvent("state:reconnecting", data);
	this.emit("$mqtt:machine/" + this._serial + "/state/reconnecting", data);
}

function trigger_state_take(data) {
	if (!this._serial) return this.bufferEvent("state:take", data);
	this.emit("$mqtt:machine/" + this._serial + "/state/take", data);
}

function trigger_state_ignored(data) {
	if (!this._serial) return this.bufferEvent("state:ignored", data);
	this.emit("$mqtt:machine/" + this._serial + "/state/ignored", data);
}

function trigger_state_scanning(data) {
	if (!this._serial) return this.bufferEvent("state:scanning", data);
	this.emit("$mqtt:machine/" + this._serial + "/state/scanning", data);
}

function trigger_state_scanned(data) {
	if (!this._serial) return this.bufferEvent("state:scanned", data);
	this.emit("$mqtt:machine/" + this._serial + "/state/scanned", data);
}

function trigger_state_finding(data) {
	if (!this._serial) return this.bufferEvent("state:finding", data);
	this.emit("$mqtt:machine/" + this._serial + "/state/finding", data);
}

function trigger_state_bluetooth(data) {
	if (!this._serial) return this.bufferEvent("state:bluetooth", data);
	this.emit("$mqtt:machine/" + this._serial + "/state/bluetooth", data);
}

function trigger_state_bluetooth_error(data) {
	if (!this._serial) return this.bufferEvent("state:bluetooth:error", data);
	this.emit("$mqtt:machine/" + this._serial + "/state/bluetooth/error", data);
}

function trigger_state_calling_error(data) {
	if (!this._serial) return this.bufferEvent("state:calling:error", data);
	this.emit("$mqtt:machine/" + this._serial + "/state/calling/error", data);
}

function bufferEvent(name, data) {
	this._eventBuffer.push({
		name: name,
		data: data
	});
}

function flushBuffer() {
	var buffer = this._eventBuffer;
	while (buffer.length) {
		var event = buffer.shift();
		this.emit("machineevents:trigger:" + event.name, event.data);
	}
}
